import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-views-common/advanced-filters/generic-advanced-filter-data";
import { SortDirection, TableSort } from "@redotech/redo-views-common/table";
import { RedoListingStatus } from "../inventory/redo-listing-status";
import { AdvancedFilterData, DEFAULT_PAGE_SIZE, viewTypes } from "./views";

export enum CatalogProductsSystemView {
  ALL = "all",
  ACTIVE = "active",
  DRAFT = "draft",
}

export const DEFAULT_CATALOG_VIEW = CatalogProductsSystemView.ACTIVE;

export const sortDefault: TableSort = {
  direction: SortDirection.DESC,
  key: "updatedAt",
};

const getStatusFilter = (status: RedoListingStatus) =>
  ({
    name: "status",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [status],
    operator: ArrayStringFilterOperator.ANY_OF,
  }) as AdvancedFilterData;

// The "All" view defaults to hiding archived listings. Seeded as a default
// filter so the user can override it (edit/clear the Status filter) and their
// choice wins.
const hideArchivedFilter: AdvancedFilterData = {
  name: "status",
  type: AdvancedFilterType.ARRAY_TO_STRING,
  value: [RedoListingStatus.ARCHIVED],
  operator: ArrayStringFilterOperator.NONE_OF,
};

const defaultColumns = [
  { key: "selected", width: 40, hidden: false },
  { key: "product-name", width: 400, hidden: false },
  { key: "description", width: 280, hidden: false },
  { key: "status", width: 100, hidden: false },
  { key: "productKind", width: 120, hidden: true },
  { key: "listings", width: 120, hidden: false },
  { key: "vendor", width: 120, hidden: false },
  { key: "price", width: 100, hidden: false },
  { key: "inventory", width: 100, hidden: false },
  { key: "updatedAt", width: 120, hidden: false },
];

export const StaticSystemViews: Record<
  CatalogProductsSystemView,
  viewTypes["catalog-products"]
> = {
  [CatalogProductsSystemView.ACTIVE]: {
    table: "catalog-products",
    name: CatalogProductsSystemView.ACTIVE,
    filters: [getStatusFilter(RedoListingStatus.ACTIVE)],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: sortDefault,
    position: 0,
    isNotEditable: true,
  },
  [CatalogProductsSystemView.DRAFT]: {
    table: "catalog-products",
    name: CatalogProductsSystemView.DRAFT,
    filters: [getStatusFilter(RedoListingStatus.DRAFT)],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: sortDefault,
    position: 1,
  },
  [CatalogProductsSystemView.ALL]: {
    table: "catalog-products",
    name: CatalogProductsSystemView.ALL,
    filters: [hideArchivedFilter],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: sortDefault,
    position: 2,
    isNotEditable: true,
  },
};

export function friendlyViewName(view: viewTypes["catalog-products"]) {
  switch (view.name) {
    case CatalogProductsSystemView.ACTIVE:
      return "Active";
    case CatalogProductsSystemView.DRAFT:
      return "Draft";
    case CatalogProductsSystemView.ALL:
      return "All";
    default:
      return view.name;
  }
}
